import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import axios from 'axios';
import logger from '../utils/logger';
var log = logger.createLogger('GraphistryWebVisualizer');
import { getPrivacyMode } from '../utils/privacy';
var AGENT_VERSION = typeof __BUILDNUMBER__ !== 'undefined' ? "".concat(__BUILDNUMBER__) : '1.0.0';
export var GraphistryWebVisualizer = /*#__PURE__*/function () {
  function GraphistryWebVisualizer() {
    _classCallCheck(this, GraphistryWebVisualizer);
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var session = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {/*csrfToken: str, activeOrganization: ?str*/};
    var basePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    log.debug({
      opts: opts,
      session: session
    }, '@GraphistryWebVisualizer');
    this.opts = _objectSpread({
      'agent_name': 'graphistry-file-uploader',
      'agent_version': AGENT_VERSION
    }, opts);
    this._session = session;
    this._data = null;
    this._basePath = basePath;
  }
  return _createClass(GraphistryWebVisualizer, [{
    key: "headers",
    value: function headers() {
      return {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRFToken': this._session.csrfmiddlewaretoken //this._session.csrfToken
      };
    }
  }, {
    key: "deleteVisualization",
    value: function deleteVisualization(_ref) {
      var _this = this;
      var dataset_id = _ref.dataset_id;
      var id = dataset_id || this._data.dataset_id;
      return new Promise(function (resolve) {
        return resolve(true);
      }).then(function () {
        var axiosCfg = {
          'method': 'DELETE',
          'url': "".concat(_this._basePath, "/web/v2/datasets/").concat(id, "/"),
          'data': {},
          'headers': _objectSpread(_objectSpread({}, _this.headers()), {}, {
            'Content-Type': 'application/json'
          }),
          'withCredentials': true,
          'timeout': 3000,
          'validateStatus': function validateStatus(status) {
            return status === 200 || status === 204;
          }
        };
        log.debug({
          axiosCfg: axiosCfg
        }, 'deleteVisualization DELETE');
        return axios(axiosCfg);
      }).then(function (resp) {
        log.debug({
          resp: resp
        }, 'deleteVisualization response');
        _this._data = resp.data;
        return resp.data;
      }).catch(function (e) {
        var msg = e && e.response && e.response.data ? e.response.data : (e || '').toString() || 'unknown response';
        log.error({
          responseData: msg
        }, 'deleteVisualization fail: passthrough for now');
        throw new Error("Error (code ".concat(e && e.response && e.response.status ? e.response.status : 'n/a', ") Failed creating visualization:\n ").concat(msg));
      });
    }

    // return promise { dataset_id }
  }, {
    key: "createVisualization",
    value: function createVisualization(_ref2) {
      var _this2 = this;
      var nodeEncodings = _ref2.nodeEncodings,
        edgeEncodings = _ref2.edgeEncodings,
        nodeFiles = _ref2.nodeFiles,
        edgeFiles = _ref2.edgeFiles,
        edgeHypergraphTransform = _ref2.edgeHypergraphTransform,
        metadata = _ref2.metadata,
        name = _ref2.name,
        description = _ref2.description,
        compute = _ref2.compute,
        layout = _ref2.layout,
        user = _ref2.user;
      log.debug({
        nodeEncodings: nodeEncodings,
        edgeEncodings: edgeEncodings,
        nodeFiles: nodeFiles,
        edgeFiles: edgeFiles,
        metadata: metadata,
        name: name,
        description: description,
        user: user
      }, '@createVisualization');
      return new Promise(function (resolve) {
        return resolve(true);
      }).then(function () {
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, user.activeOrganization ? {
          'org_name': user.activeOrganization
        } : {}), {}, {
          name: name,
          description: description,
          'node_encodings': nodeEncodings
        }, nodeFiles ? {
          'node_files': nodeFiles
        } : {}), {}, {
          'edge_encodings': edgeEncodings
        }, edgeFiles ? {
          'edge_files': edgeFiles
        } : {}), edgeHypergraphTransform ? {
          'edge_hypergraph_transform': edgeHypergraphTransform
        } : {}), {}, {
          compute: compute,
          layout: layout,
          metadata: metadata
        });
      }).then(function (data) {
        var axiosCfg = {
          'method': 'POST',
          'url': "".concat(_this2._basePath, "/web/v2/upload/datasets/"),
          'data': data,
          'headers': _objectSpread(_objectSpread({}, _this2.headers()), {}, {
            'Content-Type': 'application/json'
          }),
          'withCredentials': true,
          'timeout': 5000,
          'validateStatus': function validateStatus(status) {
            return status === 200 || status === 201;
          }
        };
        log.debug({
          axiosCfg: axiosCfg
        }, 'createVisualization post cfg');
        return axios(axiosCfg);
      }).then(function (resp) {
        log.debug({
          resp: resp
        }, 'axios resp on createVisualization');
        if (!resp.data || !resp.data.success || !resp.data.data || !resp.data.data.dataset_id) {
          var msg = 'Unexpected failure: Server signified success but response value was invalid';
          log.error(msg);
          log.error({
            resp: resp
          });
          throw new Error(msg);
        }
        //resp :: { data: { success, message, data: { dataset_id }}}
        _this2._data = resp.data.data;
        return resp.data.data; // { dataset_id }
      }).then(function (_ref3) {
        var dataset_id = _ref3.dataset_id;
        //TODO better to have done via client api, but this is not setup for jwttoken but csrf header
        log.debug({
          dataset_id: dataset_id,
          user: user
        }, 'createVisualization privacy');
        var org = user.activeOrganization;
        var username = user.username;
        var entitlements = user.entitlements;
        log.debug({
          entitlements: entitlements
        }, 'createVisualization entitlements');
        var privacy = getPrivacyMode({
          username: username,
          org: org,
          entitlements: entitlements
        });
        log.debug({
          privacy: privacy
        }, 'createVisualization privacy mode');
        if (privacy !== 'public') {
          var data = {
            'obj_pk': dataset_id,
            'obj_type': 'dataset',
            'mode': {
              'public': 'public',
              'organization': 'organization',
              'private': 'private'
            }[privacy],
            'notify': false,
            'invited_users': [],
            'mode_action': '20',
            //edit
            'message': ''
          };
          var axiosCfg = {
            'method': 'POST',
            'url': "".concat(_this2._basePath, "/web/v2/share/link/"),
            'data': data,
            'headers': _objectSpread(_objectSpread({}, _this2.headers()), {}, {
              'Content-Type': 'application/json'
            }),
            'withCredentials': true,
            'timeout': 5000,
            'validateStatus': function validateStatus(status) {
              return status === 200 || status === 201;
            }
          };
          log.debug({
            axiosCfg: axiosCfg
          }, 'createVisualization privacy post cfg');
          return axios(axiosCfg).then(function (resp) {
            return {
              dataset_id: dataset_id
            };
          });
        } else {
          return {
            dataset_id: dataset_id
          };
        }
      }).catch(function (e) {
        if (e && e.response && e.response.status && e.response.status === 404) {
          throw new Error('Error (code 404): Could not find the visualization service; check the app service, proxy service, and your network');
        }
        var msg = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : e && e.response && e.response.data ? e.response.data : (e || '').toString() || 'unknown response';
        log.error({
          e: e,
          msg: msg
        }, 'createVisualization fail');
        throw new Error("Error (code ".concat(e && e.response && e.response.status ? e.response.status : 'n/a', ") Failed creating visualization:\n ").concat(msg));
      });
    }
  }]);
}();